import React, { useState, useEffect } from "react";
import GoogleMaps from "../components/GoogleMaps";
import { useLocation } from "react-router-dom";

const Section12 = ({ contenuti }) => {
  const [isMobile, setIsMobile] = useState(false);
  const { hash } = useLocation();  
  // Se arrivasse un oggetto, lo trasformo in array
  const contenutiArray = Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

    // scroll on hash change
  useEffect(() => {
    if (hash === "#dove-siamo") {
      // togli il # e cerca l'elemento
      const id = hash.substring(1);
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]); 

  return (
    <>
      {contenutiArray.map((content, index) => {
        // 1) prendo la lat/lng (o fallback Bari)
        const {
          titolo1,
          immagineBg,
          latitudine: latStr = "41.1378075",
          longitudine: lngStr = "16.7304952",
        } = content;

        // 2) converto in numeri
        const lat = parseFloat(latStr);
        const lng = parseFloat(lngStr);

        return (
          <section
            id="dove-siamo"
            key={index}
            className="container-fluid d-flex flex-column align-items-center position-relative"
            style={{
              padding: "32px 16px",
              gap: "16px",
              backgroundImage: 'var(--bg-light-theme)',
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              minHeight: 500
            }}
          >
            {/* Onda superiore */}
            <div className="position-absolute w-100 foot-onda">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1440 50"
                preserveAspectRatio="none"
                className="w-100"
              >
                <path
                  fill="var(--bg-fill-honda)" // Colore di Bootstrap bg-light
                  d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                ></path>
              </svg>
            </div>

            {/* Titolo */}
            <h2
              className={`black-text ${isMobile
                  ? "d-block d-lg-none title-section-mobile"
                  : "d-none d-lg-block title-section"
                }`}
            >
              {titolo1}
            </h2>

            {/* Mappa */}
            <div className="container" style={{ width: "100%", height:'400px'}}>
              <GoogleMaps
                // qui passo i numeri
                mapContainerStyle={{ width: "100%", height: "100%" }}
                center={{ lat, lng }}
                zoom={15}
                markers={[{ position: { lat, lng } }]}
              />
            </div>

            {/* Onda inferiore */}
            <div className="position-absolute w-100 behind-onda">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1440 50"
                preserveAspectRatio="none"
                className="w-100"
              >
                <path
                  fill="var(--bg-fill-honda)" // Colore di Bootstrap bg-light
                  d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                ></path>
              </svg>
            </div>
          </section>
        );
      })}
    </>
  );
};

export default Section12;
